import { useUserModuleState } from "..";

export default function useIsLogged() {
    const {id} = useUserModuleState();

    return Boolean(id);
}
